/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { PasswordValidator } from "../password-validator";
import { SignInService } from "../authServices/signin.service";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  password = false;
  // invalidUser = false ;
  // invalidUserMessage: string;
  constructor(
    private router: Router,
    private signInService: SignInService,
    private dialogForgotPassword: MatDialogRef<ForgotPasswordComponent>
  ) {}
  email: string;
  phone: string;
  otp: string;
  authToken: string;
  errorMessage: string;
  isErrorVerifyngOTP = false;
  successMessage = "";
  sendOTPRequest = { email: "", phone: "" };
  inputType: string;
  otpFormGroup = new FormGroup({
    otpControl: new FormControl("", [Validators.required]),
  });
  changePasswordForm = new FormGroup(
    {
      newPassword: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
      confirmPassword: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
    },
    { validators: PasswordValidator }
  );
  userDisplay: string;
  userEmailCheck: RegExp = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
  userPhoneCheck: RegExp = /^[0-9]{10}$/;

  ngOnInit() {
    this.signInService.forgotPasswordDataPass.subscribe(
      (data) => {
        if (data.email) {
          this.sendOTPRequest.email = data.email;
          this.userDisplay = data.email;
        } else {
          this.sendOTPRequest.phone = data.phone;
          this.userDisplay = data.phone;
        }
      },
      (err) => console.log("Error while passing data from previous screen")
    );

    let requestOtp = {
      changePassword: false,
      forgotPassword: null,
      newPassword: null,
      otpGenerated: false,
      otpVerified: false,
      username: this.userDisplay,
      verifyPassword: null,
    };
    this.signInService.sendOTP(requestOtp).subscribe(
      (res: any) => {
        console.log(res);
        this.otp = res.message;
        this.authToken = res.authToken;
      },
      (err) => {
        console.log(err);
        console.log("error while sending otp");
        //  this.invalidUser = true;
        //  this.invalidUserMessage = 'Given email/phone is not valid. Please sign up to create new account';
      }
    );
  }

  get newPassword() {
    return this.changePasswordForm.get("newPassword");
  }
  get confirmPassword() {
    return this.changePasswordForm.get("confirmPassword");
  }

  get optValue() {
    return this.otpFormGroup.get("otpControl");
  }

  otpValidation() {
    let verifyForgotOtp = {
      changePassword: false,
      forgotPasswordOtp: this.otpFormGroup.get("otpControl").value,
      newPassword: null,
      otpGenerated: true,
      otpVerified: false,
      username: this.userDisplay,
      verifyPassword: null,
    };
    // if (this.userEmailCheck.test(this.userDisplay)) {
    //   verifyForgotOtp['email'] = this.userDisplay;
    // } else if (this.userPhoneCheck.test(this.userDisplay)) {
    //   verifyForgotOtp['phone'] = this.userDisplay;
    // }
    // let otp: any = this.otpFormGroup.get('otpControl').value;
    this.signInService.verifyOTP(verifyForgotOtp).subscribe(
      (res: any) => {
        if (res.verifiedOtp === true) {
          this.isErrorVerifyngOTP = false;
          this.password = !this.password;
        } else if (verifyForgotOtp.forgotPasswordOtp === "") {
          this.isErrorVerifyngOTP = true;
          this.errorMessage = "Please enter OTP to verify";
        } else {
          this.isErrorVerifyngOTP = true;
          this.errorMessage = "OTP is not valid";
        }
      },
      (err) => {
        this.isErrorVerifyngOTP = true;
        this.errorMessage = err.error.message;
      }
    );
  }
  passwordChange() {
    // this.signInService.sendOTP();
    const userdata = this.sendOTPRequest.email
      ? this.sendOTPRequest.email
      : this.sendOTPRequest.phone;
    const newpass = this.newPassword.value;
    const old = this.confirmPassword.value;

    const request = {
      changePassword: false,
      forgotPasswordOtp: this.otpFormGroup.get("otpControl").value,
      newPassword: newpass,
      otpGenerated: false,
      otpVerified: true,
      username: userdata,
      verifyPassword: newpass,
    };
    this.signInService.changePassword(request).subscribe(
      (res: any) => {
        if (res.status === true) {
          this.successMessage = res.message;
          setTimeout(() => {
            this.dialogForgotPassword.close();
          }, 500);
        } else {
          this.isErrorVerifyngOTP = true;
          this.errorMessage =
            "Something Went Wrong while changing password. Please try again.";
        }
      },
      (err) => {
        this.isErrorVerifyngOTP = true;
        this.errorMessage = err.error.message;
      }
    );
  }
}
